$(document).ready(function () {
  $(window).scroll(scrollHandler);

  function scrollHandler() {
    var a = false;
    if ($(".servicelist-wrapper").visible() && !a) {
      a = true;
      increaseServiceAmount(".dp-no", 23, 100, "");
      increaseServiceAmount(".wd-no", 122, 20, "time");
      $(".dp-barred").addClass("active");
      $(".wd-barred").addClass("active");
    }
    if (a) {
      $(window).unbind("scroll", scrollHandler);
    }
  }

  function increaseServiceAmount(b, a, f, c) {
    var e = 0;
    var d = setInterval(function () {
      e += 1;
      if (c === "time") {
        var g = moment.utc(e * 1000).format("m'ss");
        $(b).text(g);
      } else {
        $(b).text(e);
      }
      if (e === a) {
        clearInterval(d);
      }
    }, f);
  }

  $(".menu-links.lottery").hover(
    function (b) {
      var panel = $(this).find(".lottery-dropdown-wrapper");
      var arrow = $(this).find(".arrow");
      var panelOffset = ($(window).width() - panel.width()) / 2 - $(this).offset().left;
      var aroowOffset = $(this).offset().left - ($(window).width() - panel.width()) / 2 + $(this).width() / 2;
      panel.css("left", panelOffset + "px");
      arrow.css("left", aroowOffset + "px");
      panel.show();
    },
    function (b) {
      var c = $(this).find(".lottery-dropdown-wrapper");
      c.hide();
    }
  );

  // Promotion
  $(".promobanner").click(function () {
    var b = $(this).parent().find(".contentbody");
    var a = $(b).css("display");
    if (a == "block") {
      $(b).fadeOut(500);
    } else {
      $(b).fadeIn(500);
    }
  });
  $(".contentbody").each(function (a, b) {
    if (a == 0) {
      $(this).css("display", "block");
    } else {
      $(this).css("display", "none");
    }
  });

  // Sidebar
  $(".wechat").hover(
    function () {
      $(".wechatqr").stop(true, true).fadeIn(500);
    },
    function () {
      $(".wechatqr").stop(true, true).fadeOut(200);
    }
  );

  $('[api-link="user.online.service.url"]').click(function (event) {
    event.preventDefault();
    var url = $(this).attr("href");
    window.open(url, "newwindow", "width=540, height=600,resizable=yes,scrollbars=yes");
  });
});

// Date timer
$(function () {
  setInterval(updateTime, 1000);
  function updateTime() {
    var date = new Date().toLocaleString("en-US", { hour12: false }).split(" ");
    var time = date[1];
    var mdy = date[0];
    mdy = mdy.split("/");
    var month = parseInt(mdy[0]);
    var day = parseInt(mdy[1]);
    var year = parseInt(mdy[2]);
    var formattedDate = year + "-" + month + "-" + day + " " + time;

    $(".timenow").text(formattedDate);
  }
  updateTime();
});

// Banner
$(function () {
  function initBannerCarousel() {
    const bannerList = window.banner;
    const indexContainer = $("#index-banner.swiper-wrapper");
    const promoContainer = $("#promo-banner.swiper-wrapper");
    const isLoggedIn = $(".before-login.hide").length !== 0;
    bannerList &&
      bannerList !== 0 &&
      bannerList.forEach(function (item, index) {
        const { aff, imageUrl, redirectTitle, redirectUrl, redirectKey, redirectGroup, redirectPage, bannerType } =
          item;
        if (imageUrl) {
          /**
           * Redirect Group Option
           * 0 - Promo
           * 1 - Join Us
           * 2 - Lottery
           * 3 - Product
           * 4 - Others inner page (Loyalty, Customer Service)
           * 5 - 自定义
           */
          const banner = $(`
            <div class="swiper-slide" data-swiper-autoplay="5000">
              <img ${redirectUrl ? `data-redirect=${redirectUrl}` : ""} class="img" src="${imageUrl}"/>
              <div class="img-bg" style="background-image: url(${imageUrl})"></div>
            </div>
          `);

          banner.click(function () {
            if (redirectGroup === 0) {
              /**
               * Promo
               * @type {string}
               */
              if (redirectPage !== "default") {
                location.href = "promo.html#" + redirectPage;
              } else {
                location.href = "promo.html";
              }
            } else {
              window.initBannerCarouselRedirection({
                redirectUrl,
                redirectGroup,
                redirectPage,
                isLoggedIn,
              });
            }
          });

          /**
           * index append 首页type banner, promo append 优惠活动type banner
           * 轮播图类型 bannerType
           * 0 - 首页
           * 1 - 优惠活动
           * 2 - 其他
           */
          if (bannerType === 0) {
            indexContainer.append(banner);
          }
          // if (bannerType === 1) {
          //   promoContainer.append(banner);
          // }
        }
      });

    if (bannerList && bannerList.length) {
      var mySwiper = new Swiper(".swiper-container.banner", {
        speed: 400,
        autoplay: {
          delay: 5000,
        },
        loop: true,
        // If we need pagination
        pagination: {
          el: ".swiper-pagination.banner",
        },
      });
    }
  }

  if (Pace) {
    Pace.on("done", initBannerCarousel);
  } else {
    $(window).load(initBannerCarousel);
  }
});

function gameWrapperDetector() {
  var menuOffset = $(".main-menu .menu-links.lottery").offset().left;
  var windowWidth = $(window).width();
  var menuWidth = $(".main-menu .menu-links.lottery").outerWidth();

  var offsetRight = windowWidth - (menuOffset + menuWidth);
  var lotteryWrapperWidth = $(".lottery-dropdown-wrapper").innerWidth();

  if (offsetRight < lotteryWrapperWidth / 2) {
    $(".lottery-dropdown-wrapper").addClass("right");
  }
}

// promotion

$(function () {
  if (window.promo) {
    renderPromo(window.promo);
  } else {
    Object.defineProperty(window, "promo", {
      set: function (data) {
        renderPromo(data);
      },
    });
  }

  $(".promo-menu-links").click(function () {
    var dataType = $(this).data("type");
    $(this).siblings().removeClass("active");
    $(this).addClass("active");

    if (dataType === -1) {
      $(".promo-box").show();
    } else {
      $('.promo-box[data-type="' + dataType + '"]').show();
      $('.promo-box:not([data-type="' + dataType + '"])').hide();
    }
  });

  function registerPromo(promoId) {
    api.registerPromo(promoId);
  }

  function renderPromo(promoData) {
    if (Array.isArray(promoData)) {
      var promoWrapper = $("#promotionWrapper");
      let promohash = location.hash !== "" ? location.hash.split("#")[1] : "";

      promoData.forEach(function (value, index) {
        var promoItem = $(`<div class="promo-box" data-type="${value.type}"></div>`);
        var promoId = value.promoId;
        var requestToJoin = value.requestToJoin;
        var firstDepositPromoJoinMsg = value.firstDepositPromoJoinMsg;

        promoItem.append(
          $(`
            ${
              value.imagePath
                ? `
                  <div class="sub-content-item-header" data-header="${promoId}" style="font-size:0;">
                    <img class="banner" src="${value.imagePath}" alt="${value.title}" title="${value.title}"/>
                  </div>
                  `
                : `
                  <div class="sub-content-item-header">
                    <h3>${value.title}</h3>
                  </div>
                `
            }
            <div class="sub-content-item-content" ${
              promohash.length > 0 && promohash === promoId ? `style="display:block"` : ""
            }>
              ${value.content}
                 ${
                   requestToJoin
                     ? `
                     <div
                       class="promo--modal--footer"
                       style="display: -webkit-box; display: -ms-flexbox; display: flex; -webkit-box-align: center; -ms-flex-align: center; align-items: center; -webkit-box-pack: center; -ms-flex-pack: center; justify-content: center; height: 50px;"
                     >
                       ${
                         firstDepositPromoJoinMsg
                           ? `
                             <div class="promo--modal--footer--info" style="color: #999;">
                               ${firstDepositPromoJoinMsg}
                             </div>
                           `
                           : `
                             <button
                               class="promo--modal--footer--register-promo"
                               data-id="${promoId}"
                               style="cursor:pointer;padding: 10px 20px;outline: none;width: 100px; display: -webkit-box; display: -ms-flexbox; display: flex; -webkit-box-align: center; -ms-flex-align: center; align-items: center; -webkit-box-pack: center; -ms-flex-pack: center; justify-content: center; background-color: #328fff; color: #fff;border-radius: 4px; border:0;"
                             >
                               申请参与
                             </button>
                           `
                       }
                     </div>
                   `
                     : ""
                 }
            </div>
         
            `)
        );
        promoWrapper.append(promoItem);
      });

      $(".promo-box .sub-content-item-header").click(function (e) {
        e.preventDefault();
        $(this).siblings(".sub-content-item-content").slideToggle();
      });

      $(".promo--modal--footer--register-promo").click(function (e) {
        e.preventDefault();
        var promoId = $(this).data("id");
        registerPromo(promoId);
      });

      if (promohash.length > 0) {
        const scrollTop = $(`.sub-content-item-header[data-header='${promohash}']`).offset().top - 50;
        $("html, body").animate({ scrollTop: scrollTop }, 1000);
      }
    }
  }
});

// faqs

$(document).ready(function () {
  // var url = window.location.hash;
  // var idx = url.indexOf("#");
  // hash = url !== "" ? url.substring(idx + 1) : "";
});

$(".sub-content.faq .itms").click(function (e) {
  var cur = $(this).index() + 1;
  $(this).addClass("active");
  $(".itms").not($(this)).removeClass("active");
  $(".faqcontent #content" + cur + ".col2").show();
  $(".faqcontent .col2")
    .not($(".faqcontent #content" + cur + ".col2"))
    .hide();
});

if ($(".qrbenefit-wrapper").length) {
  $(window).on("scroll", sectionServicesAnim);
}

function sectionServicesAnim() {
  if ($(".qrbenefit-wrapper").offset().top < $(window).scrollTop() + window.innerHeight - 200) {
    $(".bar-item .progress .progress-bar").each(function (i, elem) {
      // var value = $(elem).attr("data-width");
      // var duration = $(elem).attr("data-duration") + "ms" || "500ms";
      $(elem).css("transform", "translateX(0)");
    });
    $(window).unbind("scroll", sectionServicesAnim);
  }
}

$(document).ready(function () {
  if ($(".game-content .game-icons").length !== 0) {
    $(".game-content .game-icons").addClass("ready");
    setInterval(function () {
      $(".game-content .game-icons").toggleClass("ready");
    }, 2000);
  }
});
